<template>
    <div class="mb-8">
        <img
            :src="image.src"
            :alt="image.alt"
            :width="image.width"
            :height="image.height"
            :loading="image.loading as 'eager' | 'lazy' | undefined"
            :decoding="image.decoding as 'async' | 'auto' | 'sync' | undefined"
            :srcset="image.srcset"
            class="h-auto w-full rounded-[1rem]"
        />
        <AtomsBody1 class="mt-3 px-5 text-base-black-60">
            <slot />
        </AtomsBody1>
    </div>
</template>

<script setup lang="ts">
const { image } = defineProps<{
    image: {
        src: string;
        alt: string;
        width: number;
        height: number;
        loading: "eager" | "lazy" | undefined;
        decoding: "async" | "auto" | "sync" | undefined;
        srcset: string;
    };
}>();
</script>
